export interface FeedbackFormValues {
  overallDeliveryExperience: number | null // 1-5 CSAT
  negativeExperienceReasons: string[]
  driverSatisfaction: boolean | null
  driverIssueReasons: string[]
  trackingExperience: boolean | null
  trackingIssueReasons: string[]
  additionalDeliveryComments: string
  supportExperience: number | null // 1-5 CSAT
  supportIssueReasons: string[]
  additionalSupportComments: string
  consentToFollowUp: boolean
}

export const INITIAL_FEEDBACK_VALUES: FeedbackFormValues = {
  overallDeliveryExperience: null,
  negativeExperienceReasons: [],
  driverSatisfaction: null,
  driverIssueReasons: [],
  trackingExperience: null,
  trackingIssueReasons: [],
  additionalDeliveryComments: '',
  supportExperience: null,
  supportIssueReasons: [],
  additionalSupportComments: '',
  consentToFollowUp: false,
}

export const DRIVER_PRAISE_OPTIONS = [
  'Delivered with care',
  'Above & beyond',
  'Followed instructions',
  'Respectful of property',
] as const

export type DriverPraiseReason = (typeof DRIVER_PRAISE_OPTIONS)[number]

export const NEGATIVE_EXPERIENCE_OPTIONS = [
  'It was late',
  "Instructions weren't followed",
  'Package left in a bad place',
  'Delivered to wrong address',
  'Never received delivery',
  'Damaged package',
  'Unprofessional driver',
  'Bad photo',
] as const

export type NegativeExperienceReason = (typeof NEGATIVE_EXPERIENCE_OPTIONS)[number]

export const TRACKING_ISSUE_OPTIONS = [
  'Inaccurate updates',
  'Not enough updates',
  'Too many updates',
  "Page/app didn't work",
] as const

export type TrackingIssueReason = (typeof TRACKING_ISSUE_OPTIONS)[number]

export const SUPPORT_ISSUE_OPTIONS = [
  "My issue wasn't resolved",
  'Resolution took too long',
  "Agent wasn't helpful",
  'Process was too difficult',
  "Promised follow-up didn't happen",
  'Technical problem with support',
  'Problem was with delivery/app',
  'Disagree with the outcome',
] as const

export type SupportIssueReason = (typeof SUPPORT_ISSUE_OPTIONS)[number]
